import { TPlayResultTypes } from '@/constants';

export function formatQuarter(quarter: number) {
  if (quarter < 5) return `Q${quarter}`;
  return `OT${quarter - 4}`;
}

export const ordinalSuffixOf = (i: number) => {
  const j = i % 10;
  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return `${i}rd`;
  }
  return `${i}th`;
};

export function setUrlSearchParam(key: string, val: any) {
  const currentURL = window.location.href;
  const searchParams = new URLSearchParams(window.location.search);

  searchParams.set(key, val);

  const newURL = `${currentURL.split('?')[0]}?${searchParams.toString()}`;

  window.history.pushState(null, null, newURL);
}

export function deleteUrlSearchParams() {
  const currentURL = window.location.href;
  const newURL = currentURL.split('?')[0];
  window.history.pushState(null, null, newURL);
}

export function getUrlSearchParam(key: string): string {
  return new URLSearchParams(window.location.search).get(key);
}

export const refEventValue = (driveNum: number, playNum: number): string => `${driveNum},${playNum}`;
